import React from "react";
import {TrailEnums} from "./commonFilesJS/enums";
import {searchStudentTrails} from "./commonFilesJS/axiosRequests";
import TableAntD from "../../../common/TableAntD";

const TrailClosedContent = (props) => {
    const {key} = props;
    const {TRAIL_TABLE_COLUMNS} = TrailEnums();
    return <TableAntD
            pagingDependencies={[key]}
            pagingData={{fetchFunction:searchStudentTrails, params:{assignmentState:'CLOSED'}}}
            columnData={TRAIL_TABLE_COLUMNS}
            rowKey={'key'}
            dynamicWidth={true}
        />
}
export default TrailClosedContent;
